import { useState } from 'react';

import usePagination from '@hooks/usePagination';
import { FAQ_DATA } from '@lib/DUMMY';

import { Wrapper } from '@components/styled/StyledComponents';
import { TableBody, EmptyTable } from '@components/share/Table/table.style';
import Headline from '@components/layout/Headline';
import FilterButtons from '@components/layout/FilterButtons';
import FaqListRow from '@components/features/Faq/FaqListRow';
import Loader from '@components/share/Loader';
import Pagination from '@components/layout/Pagination';

const Faq = () => {
    const [loading, setLoading] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState(0);
    // 페이지네이션 관련 상태
    const [take, setTake] = useState(8);
    const [preCursor, setPreCursor] = useState(0);
    const [nextCursor, setNextCursor] = useState(0);
    const [cursorOption, setCursorOption] = useState<boolean | null>(null);

    const totalLength = FAQ_DATA.length;

    // 페이지네이션
    const {
        pageIndex,
        setPageIndex,
        pageGroupLength,
        prevPageHandler,
        nextPageHandler,
        prevPageGroupHandler,
        nextPageGroupHandler,
        resetPaginationHandler,
        disabled
    } = usePagination(
        take,
        totalLength,
        setPreCursor,
        setNextCursor,
        setCursorOption,
        FAQ_DATA, // TODO: 임시
        'id' // TODO: 임시
    );

    if (loading) return <Loader />;

    return (
        <Wrapper>
            <Headline title="자주하는 질문" />
            <FilterButtons
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
                options={[
                    { title: '전체', value: 0 },
                    { title: '서비스 일반문의', value: 1 },
                    { title: '구독 관련 서비스 이용', value: 2 },
                    { title: '홍보 미디어 신청 문의', value: 3 }
                ]}
            />
            <TableBody $height={72 * 8}>
                {loading && <Loader />}
                {totalLength === 0 ? (
                    <EmptyTable>보유 장비가 존재하지 않습니다.</EmptyTable>
                ) : (
                    FAQ_DATA.slice(
                        pageGroupLength + pageIndex,
                        pageGroupLength + pageIndex + take
                    ).map((data, idx) => (
                        <FaqListRow key={`${idx}-faq-list`} data={data} />
                    ))
                )}
            </TableBody>
            <Pagination
                take={take}
                pageIndex={pageIndex}
                setPageIndex={setPageIndex}
                pageGroupLength={pageGroupLength}
                totalLength={totalLength}
                prevPageHandler={prevPageHandler}
                nextPageHandler={nextPageHandler}
                prevPageGroupHandler={prevPageGroupHandler}
                nextPageGroupHandler={nextPageGroupHandler}
                resetPaginationHandler={resetPaginationHandler}
                disabled={disabled}
                BORDER
            />
        </Wrapper>
    );
};

export default Faq;
